import {
  ViewChild,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-payment-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class PaymentListComponent implements OnInit, OnDestroy {
  @ViewChild('infiniteScroll') infiniteScroll: InfiniteScroll;
  @Input() set urlComing(value: any) {
    if (value && this.url !== value) {
      this.url = value;
      this.setDefault();
    }
  }
  @Input() typeUser: string = '';
  @Input() hiddeDelete: boolean = false;
  @Output() user = new EventEmitter();
  @Input() isAdmin = '';
  @Input() set orderId(value) {
    if (value) {
      this.id = value;
      // this.setDefault('id');
    }
  }
  public url = '';
  public products: any[] = [];
  private page = 1;
  private totalPages = undefined;
  public savedIndex = undefined;
  public search = '';
  public type = '';
  public loaded = false;
  public id = undefined;
  public rols = [
    {
      id: 'payment',
      value: 'Aprobado',
    },
    {
      id: 'delivered',
      value: 'Entregado',
    },
    {
      id: 'declined',
      value: 'Rechazado',
    },
  ];
  private _subscription: Subscription = new Subscription();
  constructor(private httpSv: HttpService, private formSv: FormServices) {}

  ngOnInit() {
    this._subscription.add(
      this.formSv.deleteListProductObs.subscribe(async (id) => {
        if (id === 'reloadListProduct') {
          this.setDefault();
          return;
        }
        const index = this.products.findIndex((item) => item.id === id);
        this.products.splice(index, 1);
      })
    );

    if (!this.id) {
      this.loaded = true;
    }
  }

  setDefault() {
    this.page = 1;
    this.products = [];
    this.loaded = false;
    this.getData();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  trackByItems(index, item) {
    return item.id;
  }

  async getData() {
    try {
      const params = {
        pag: this.page,
        type: this.id ? 'order' : this.type,
        search: this.search,
        isAdmin: this.isAdmin,
        orderId: this.id || '',
        paymentId: this.id || '',
        unsave: this.typeUser === 'register' ? '' : 'true',
      };
      const res: any = await this.httpSv.itemIndex(this.url, '', params);
      if (!this.totalPages) this.totalPages = res.data.meta.last_page;
      this.page++;
      if (this.id) {
        this.id = undefined;
        this.loaded = false;
        this.products = [];
        this.totalPages = undefined;
      } else {
        this.loaded = true;
      }
      this.products.push(...res.data?.data);
      this.products.map((item) => {
        if (item.file) {
          !item.media && (item.media = []);
          item.media.push({ file: item.file });
        }
      });

      if (!this.products.length) {
        this.infiniteScroll?.complete();
      }
      if (!this.loaded) {
        this.showUser(this.products[0]);
      }
    } catch (err) {
      console.error(err);
    }
  }

  searchProduct(ev) {
    if (ev.id || ev.id === '') {
      this.type = ev?.id;
    }
    this.infiniteScroll.setVisible();
    this.infiniteScroll.observe();
    this.page = 1;
    this.search = ev?.value;
    this.products = [];
    this.totalPages = 1;
  }

  async loadData(event: InfiniteScroll) {
    if (this.products.length) {
      if (this.page >= this.totalPages) {
        event.complete();
      } else {
        event.disconnect();
        await this.getData();
        event.observe();
      }
    } else {
      this.loaded = false;
    }
  }

  showUser(user) {
    this.user.emit(user);
  }
}
